import type { TeamId } from '@cyphex/types/common';

/** Query keys for the Teams surface. Merge into `src/constants/queryKeys.ts`
 *  once a shared registry exists — the tuples are already namespaced. */
export const TEAM_KEYS = {
  all: ['teams'] as const,
  list: () => [...TEAM_KEYS.all, 'list'] as const,
  detail: (teamId: TeamId) => [...TEAM_KEYS.all, 'detail', teamId] as const,
  channels: (teamId: TeamId) => [...TEAM_KEYS.all, 'channels', teamId] as const,
  members: (teamId: TeamId) => [...TEAM_KEYS.all, 'members', teamId] as const,
  discover: () => [...TEAM_KEYS.all, 'discover'] as const,
  joinRequests: () => [...TEAM_KEYS.all, 'join-requests'] as const,
} as const;
